import { useState, useCallback } from 'react';
import {
  NewCompanyWizardData,
  NewCompanyStep1Data,
  NewCompanyStep2Data,
  NewCompanyStep3Data,
  NEW_COMPANY_WIZARD_INITIAL_STATE,
} from '../types/newCompanyWizard.types';

export function useNewCompanyWizard() {
  const [currentStep, setCurrentStep] = useState(0);
  const [wizardData, setWizardData] = useState<NewCompanyWizardData>(
    NEW_COMPANY_WIZARD_INITIAL_STATE
  );

  const updateStep1 = useCallback((updates: Partial<NewCompanyStep1Data>) => {
    setWizardData((prev) => ({ ...prev, step1: { ...prev.step1, ...updates } }));
  }, []);

  const updateStep2 = useCallback((updates: Partial<NewCompanyStep2Data>) => {
    setWizardData((prev) => ({ ...prev, step2: { ...prev.step2, ...updates } }));
  }, []);

  const updateStep3 = useCallback((updates: Partial<NewCompanyStep3Data>) => {
    setWizardData((prev) => ({ ...prev, step3: { ...prev.step3, ...updates } }));
  }, []);

  const nextStep = useCallback(() => {
    setCurrentStep((prev) => Math.min(2, prev + 1));
  }, []);

  const previousStep = useCallback(() => {
    setCurrentStep((prev) => Math.max(0, prev - 1));
  }, []);

  const goToStep = useCallback((step: number) => {
    setCurrentStep(step);
  }, []);

  const resetWizard = useCallback(() => {
    setCurrentStep(0);
    setWizardData(NEW_COMPANY_WIZARD_INITIAL_STATE);
  }, []);

  return {
    currentStep,
    wizardData,
    updateStep1,
    updateStep2,
    updateStep3,
    nextStep,
    previousStep,
    goToStep,
    resetWizard,
  };
}
